import { SelectOption } from '@frontend/basic-forms';
import { IoTEnumClient } from '@frontend/iot/api';
import { IoTType } from '@frontend/iot/types';
import { useEffect, useState } from 'react';

interface ViewProps {
    options: SelectOption<IoTType>[];
    isLoading: boolean;
}

export const useIoTTypeSelect = (): ViewProps => {
    const [options, setOptions] = useState<SelectOption<IoTType>[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setIsLoading(true);
        IoTEnumClient.fetchIoTTypes()
            .then((types) => {
                setOptions(
                    types.map((type) => ({
                        value: type as IoTType,
                        label: type.replace(/_/g, ' ')
                    }))
                );
            })
            .finally(() => setIsLoading(false));
    }, []);

    return { options, isLoading };
};
